import type { IconProps } from './../../models/icon';

export function MenuIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M7.71432 0.857178H2.57146C1.62469 0.857178 0.857178 1.62469 0.857178 2.57146V7.71432C0.857178 8.66109 1.62469 9.42861 2.57146 9.42861H7.71432C8.66109 9.42861 9.42861 8.66109 9.42861 7.71432V2.57146C9.42861 1.62469 8.66109 0.857178 7.71432 0.857178Z"
        />
        <path
          fill={secondaryColor}
          d="M21.4287 0.857178H16.2858C15.3391 0.857178 14.5715 1.62469 14.5715 2.57146V7.71432C14.5715 8.66109 15.3391 9.42861 16.2858 9.42861H21.4287C22.3755 9.42861 23.143 8.66109 23.143 7.71432V2.57146C23.143 1.62469 22.3755 0.857178 21.4287 0.857178Z"
        />
        <path
          fill={secondaryColor}
          d="M7.71432 14.5714H2.57146C1.62469 14.5714 0.857178 15.3389 0.857178 16.2857V21.4286C0.857178 22.3754 1.62469 23.1428 2.57146 23.1428H7.71432C8.66109 23.1428 9.42861 22.3754 9.42861 21.4286V16.2857C9.42861 15.3389 8.66109 14.5714 7.71432 14.5714Z"
        />
        <path
          fill={secondaryColor}
          d="M21.4287 14.5714H16.2858C15.3391 14.5714 14.5715 15.3389 14.5715 16.2857V21.4286C14.5715 22.3754 15.3391 23.1428 16.2858 23.1428H21.4287C22.3755 23.1428 23.143 22.3754 23.143 21.4286V16.2857C23.143 15.3389 22.3755 14.5714 21.4287 14.5714Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M7.71432 0.857178H2.57146C1.62469 0.857178 0.857178 1.62469 0.857178 2.57146V7.71432C0.857178 8.66109 1.62469 9.42861 2.57146 9.42861H7.71432C8.66109 9.42861 9.42861 8.66109 9.42861 7.71432V2.57146C9.42861 1.62469 8.66109 0.857178 7.71432 0.857178Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M21.4287 0.857178H16.2858C15.3391 0.857178 14.5715 1.62469 14.5715 2.57146V7.71432C14.5715 8.66109 15.3391 9.42861 16.2858 9.42861H21.4287C22.3755 9.42861 23.143 8.66109 23.143 7.71432V2.57146C23.143 1.62469 22.3755 0.857178 21.4287 0.857178Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M7.71432 14.5714H2.57146C1.62469 14.5714 0.857178 15.3389 0.857178 16.2857V21.4286C0.857178 22.3754 1.62469 23.1428 2.57146 23.1428H7.71432C8.66109 23.1428 9.42861 22.3754 9.42861 21.4286V16.2857C9.42861 15.3389 8.66109 14.5714 7.71432 14.5714Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M21.4287 14.5714H16.2858C15.3391 14.5714 14.5715 15.3389 14.5715 16.2857V21.4286C14.5715 22.3754 15.3391 23.1428 16.2858 23.1428H21.4287C22.3755 23.1428 23.143 22.3754 23.143 21.4286V16.2857C23.143 15.3389 22.3755 14.5714 21.4287 14.5714Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="24" height="24" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
}
